import React, { ForwardedRef, forwardRef, ReactNode } from 'react';
import { css } from '@emotion/css';
import {
  Button as BsButton,
  ButtonProps as BsButtonProps,
} from 'react-bootstrap';
import { CSSObject } from '@emotion/react';
import { classCombine } from 'tradevan-ui/consts';
import ButtonVariantEnum from './enum';

export interface CustomButtonProps {
  /** 變化： 顏色、外框、軟色 */
  variant?: ButtonVariantEnum;
  /** 圓角 */
  rounded?: boolean;
  /** 開頭文字區塊(有灰底) */
  startLabel?: ReactNode;
  /** 結尾文字區塊(有灰底) */
  endLabel?: ReactNode;
  /** 開頭 Icon(沒灰底) */
  startIcon?: ReactNode;
  /** 結尾 Icon(沒灰底) */
  endIcon?: ReactNode;
  /** 寬度尺寸 */
  width?: 'xl' | 'lg' | 'md' | 'sm' | 'xs';
  /** 全寬 */
  block?: boolean;
}

export interface ButtonProps
  // 由於原生已經有variant，我們自己要在variant裡面增加新的元素
  // 所以使用omit 把variant從繼承(extends)的BsButtonProps裡面移除
  extends Omit<BsButtonProps, 'variant' | 'style'>,
    CustomButtonProps {
  style?: CSSObject;
}

const Button = forwardRef(
  (props: ButtonProps, ref: ForwardedRef<HTMLButtonElement>): JSX.Element => {
    const {
      className,
      variant = ButtonVariantEnum.primary,
      rounded,
      startLabel,
      endLabel,
      startIcon,
      endIcon,
      width,
      block,
      style,
      children,
      ...other
    } = props;

    const styleToClass = css({ ...style });

    return (
      <BsButton
        ref={ref}
        variant=""
        className={classCombine(
          styleToClass,
          className && `${className}`,
          variant && `btn-${variant}`,
          rounded && 'btn-rounded',
          width && `width-${width}`,
          block && 'btn-block',
        )}
        {...other}
      >
        {startLabel && <span className="btn-label">{startLabel}</span>}
        {startIcon && <span className="mr-1">{startIcon}</span>}
        {children}
        {endIcon && <span className="ml-1">{endIcon}</span>}
        {endLabel && <span className="btn-label-right">{endLabel}</span>}
      </BsButton>
    );
  },
);

export default Button;
